// extracted by mini-css-extract-plugin
export default {"container":"Jp-z","heading":"Kp-z","text":"Lp-z","info":"Mp-z","link":"Np-z","fullMaxWidth":"Op-z"};